import React from "react";
import BannerCardContainer from "../hot-sale-banner-card/BannerCardContainer";
import { Inner } from "./styles";

export default function HotSaleModal({ data }) {
	return (
		<Inner>
			{data.products?.map((d, idx) => (
				<BannerCardContainer
					key={`BannerCard_${idx}`}
					item={d.product}
					campaignOffer={data.campaignOffer}
				/>
			))}
		</Inner>
	);
}
